import { EmptyState } from '~/components/EmptyState';

export const PlaceholderView = ({ title = 'Coming Soon' }: { title?: string }) => (
  <EmptyState title={title} description="This feature is coming soon." />
);
